export function animation() {
  // フッター TOPスクロールボタン
  // document.getElementById("js-scrollTop").addEventListener("click", () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // });

  // フェードインアニメーション
  const fadeInElements = document.querySelectorAll(".js-fade-in");
  fadeInElements.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            element.style.transition = "opacity 1s ease-out, transform 1s ease-out";
            element.style.opacity = 1;
            element.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });

  const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
  fadeInLeftElements.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            element.style.transition = "opacity 1s ease-out, transform 1s ease-out";
            element.style.opacity = 1;
            element.style.transform = "translateX(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });

  const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
  fadeInRightElements.forEach((element) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            element.style.transition = "opacity 1s ease-out, transform 1s ease-out";
            element.style.opacity = 1;
            element.style.transform = "translateX(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(element);
  });
}
